import { spawn } from 'redux-saga/effects'
import { rootSaga as SessionSaga } from './session'
import { rootSaga as EnforcementSaga } from './enforcement'
import { rootSaga as ReservationSaga } from './reservation'
import { rootSaga as kegSizeOptionsSaga } from './keg_size_options'
import { rootSaga as productOptionSaga} from './product_options'
import { rootSaga as confirmationSaga} from './reservation/confirmation'
import { rootSaga as reservationsIndexSaga} from './reservation/index'
import { rootSaga as reservationsSearchSaga} from './reservation/search'
import { rootSaga as showOrderSaga} from './reservation/show'
import { rootSaga as newProductSaga} from './products/new'
import { rootSaga as newSignUpSaga } from './sign_up/new'
import { rootSaga as newAccountSaga } from './sign_up/account_information'
import { rootSaga as accountSaga} from './account'
import { rootSaga as inventorySaga } from './inventory'
import { rootSaga as productSaga } from './products'
import { rootSaga as showProductSaga } from './products/show'
import { rootSaga as updateProductSaga } from './products/update'
import { rootSaga as customersSaga } from './customers'
import { rootSaga as customerSaga } from './customers/show'
import { rootSaga as accountingSaga } from './accounting'
import { rootSaga as stripeInfoSaga } from './stripe_settings'
import { rootSaga as inventoryManagementSaga } from './inventory/new'
import { rootSaga as checkoutSaga } from './checkout'
import { rootSaga as kegsSaga } from './kegs'
import { rootSaga as accountUpdateSaga } from './account/update'
import { rootSaga as kegSizeSaga } from './keg_sizes'
import { rootSaga as refundSaga } from './refund'
import { rootSaga as inviteSaga } from './inviteUser'

export default function * () {
  return yield [
    spawn(SessionSaga),
    spawn(EnforcementSaga),
    spawn(ReservationSaga),
    spawn(kegSizeOptionsSaga),
    spawn(productOptionSaga),
    spawn(confirmationSaga),
    spawn(accountSaga),
    spawn(reservationsIndexSaga),
    spawn(newProductSaga),
    spawn(newSignUpSaga),
    spawn(newAccountSaga),
    spawn(inventorySaga),
    spawn(productSaga),
    spawn(customersSaga),
    spawn(customerSaga),
    spawn(accountingSaga),
    spawn(stripeInfoSaga),
    spawn(inventoryManagementSaga),
    spawn(showProductSaga),
    spawn(updateProductSaga),
    spawn(checkoutSaga),
    spawn(reservationsSearchSaga),
    spawn(showOrderSaga),
    spawn(kegsSaga),
    spawn(accountUpdateSaga),
    spawn(kegSizeSaga),
    spawn(refundSaga),
    spawn(inviteSaga)
  ]
}



// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js